/** @jsx jsx */
import React from 'react';
import { css, jsx } from '@emotion/core';
import { Marker } from './meta/Marker';
import { GlobalStyles, Paragraph, TypographyVisualStyle } from 'react-magma-dom';
import { Main } from './a11y/landmark/Main';
import { AlfredGlobalStyles } from './basic/AlfredGlobalStyles';
import { ContentContainer, WidgetHeader, WidgetContent, WidgetContentInner, SignInFooter, Link } from './styled';
import { CengageLogo } from './basic/CengageLogo';

export const TEST_ID = {
  MARKER: 'marker-logout-success',
};

export interface LogoutSuccessProps {
}


export const LogoutSuccess: React.FunctionComponent<LogoutSuccessProps> = (
  ) => {
  return (
    <React.Fragment>
      <GlobalStyles />
      <AlfredGlobalStyles />
      <ContentContainer>
        <WidgetHeader>
          <CengageLogo />
        </WidgetHeader>
        <Main>
          <WidgetContent>
            <WidgetContentInner>
              <div
                css={css`
                  // Center this and make it not terribly wide
                  margin: 0 auto;
                  max-width: 60vmax;
                `}
              >
                <Marker testId={TEST_ID.MARKER} />
                <Paragraph
                  css={css`
                  text-align: center;
                `}
                  visualStyle={TypographyVisualStyle.bodyMedium}
                >
                You have successfully been logged out. You may close this tab.
                </Paragraph>
              </div>
            </WidgetContentInner>
            <SignInFooter>
              Return to {' '}
              <Link href="https://www.cengage.com">Cengage</Link>
            </SignInFooter>
          </WidgetContent>
        </Main>
      </ContentContainer>
    </React.Fragment>
  );
};
